export default __webpack_public_path__ + "static/media/e-bunifikasi-logotype-d.9d8aa97e.svg";